import { BENEFITS } from '@/constants/signup.constants';

export type BenefitsProps = {
    baseClassName?: string;
};

export const Benefits = ({ baseClassName, ...props }: BenefitsProps) => {

    return (
        <div className={`${baseClassName}-marketing`}>
            <div className={`${baseClassName}-marketing__section`}>
                <div className={`${baseClassName}-marketing__caption`}>
                    Join a Community of 5000+ Happy Users Harnessing the Power of Data
                </div>
                <div className={`${baseClassName}-marketing__benefits`}>
                    {BENEFITS?.map((benefit, index) => (
                        <div className={`${baseClassName}-marketing__benefits-details`} key={index + benefit.title}>
                            <div className={`${baseClassName}-marketing__benefits-details-icon`}>
                                <img src={benefit.icon} alt={'benefit-icon'} />
                            </div>
                            <div className={`${baseClassName}-marketing__benefits-details-text`}>
                                <span className={`${baseClassName}-marketing__benefits-details-text-title`}>
                                    {benefit.title}
                                </span>
                                <span className={`${baseClassName}-marketing__benefits-details-text-description`}>
                                    {benefit.description}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Benefits;

Benefits.displayName = 'Benefits';
